import React, { useState } from "react";

/**
 * Тултип DS (canon-session 2026-07-24): показывается на hover над
 * якорем. Плавающий → допускается тень (canon: тень только у плавающих).
 */
export function Tooltip({
  label,
  children,
}: {
  label: React.ReactNode;
  children: React.ReactNode;
}) {
  const [show, setShow] = useState(false);
  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && (
        <span className="absolute bottom-[120%] left-1/2 -translate-x-1/2 z-50 whitespace-nowrap rounded-md bg-bg-elevated border border-border text-text-primary text-[11.5px] px-2.5 py-1.5 shadow-elevated">
          {label}
        </span>
      )}
    </span>
  );
}
